import React, { useState } from 'react';
import {Link} from 'react-router-dom';
import Bgimg from '../../static/authimg2.png';

import UserRequest from '../userrequests/userRequest';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import CreateIcon from '@material-ui/icons/Create';
import {makeStyles,createMuiTheme,ThemeProvider} from '@material-ui/core/styles';

import NavBar from '../../components/Navbar';
import Styles from './userprofile.module.css';
import { useSelector } from 'react-redux';

const theme = createMuiTheme({
    palette: {
        primary: {
          main: "#4caf50",
        },
        secondary: {
          main: "#ffffff",
        },
      },
})

const useStyles = makeStyles((theme)=>({
    root:{
        flexGrow:1
    },
    butdiv:{
        flexGrow:1,
    },
    menuButton:{
        marginRight:theme.spacing(2),
    },
    title:{
        fontWeight:"700",
        marginRight:theme.spacing(2)
        
    },
    avatar:{
        height:theme.spacing(20),
        width:theme.spacing(20),
        background:"#fff",
        fontFamily:"Poppins, sans-serif"
    },
    
    butarea:{
        padding:"1em",
        borderRadius:"1em",
        margin:"1em 0",
        width:"100%",
        position:"relative",
        background:"rgba(255,255,255,0.25)",
        boxShadow:"0px 4px 35px 1px rgba(50,50,50,.3)",
        // backdropFilter:"blur(2px)"
        letterSpacing:"3px"
    },
    profnav:{
        borderBottom:"1px solid #fff",
        flex:"1 1 auto",
        padding:"1em 1em",
        cursor:"pointer",
        fontSize:"1em",
        textAlign:"center"
    },
    active:{
        borderBottom:"3px solid #fff",
        flex:"1 1 auto",
        padding:"1em 1em",
        fontWeight:"600",
        background:"#fff",
        color:"#000",
        borderTopRightRadius:"1em",
        borderTopLeftRadius:"1em",
        color:"#1E6F11",
        textAlign:"center"
    }
}));


export default function UserProfile() {
    
    const classes  = useStyles();
    const userSignin = useSelector(state=>state.userSignin);
    const {loading,userInfo,error} = userSignin;
    const [kdis,setKdis] = useState(true);
    const [enq,setEnq] = useState(false);
    const [req,setReq] = useState(false);

    const handleDis = () =>{
        setKdis(true);
        setEnq(false);
        setReq(false);
    }
    const handleEnq = () =>{
        setKdis(false);
        setEnq(true);
        setReq(false);
    }
    const handleReq = () =>{
        setKdis(false);
        setEnq(false);
        setReq(true);
    }
    return(
        <div>
            <ThemeProvider theme={theme}>
            <NavBar />
            <img src={Bgimg} style={{position:"fixed",left:"-27em",bottom:"-8em",zIndex:"-100"}}></img>
                <Grid item container alignItems="center" justify="center" direction="column" className={Styles.avatar}>
                <Badge
                   overlap="circle"
                   anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'right',
                   }}
                   badgeContent={<IconButton style={{background:"#4caf50"}}><CreateIcon /></IconButton>}
                   >
                     <Avatar className={classes.avatar} src="https://res.cloudinary.com/marcos-yash/image/upload/v1616877820/avatar1_kijavl_iopsya.png"></Avatar>
                     </Badge>
                <Typography align="center" style={{color:"#fff",fontSize:"1.5em",marginTop:"1em"}}>
                    @{userInfo.name}
                </Typography>
                </Grid> 
                <Grid item container direction="row" justify="space-evenly" style={{color:"#fff",padding:"0em 1em"}}>
                    <Typography  className={enq?classes.active:classes.profnav} onClick={handleEnq}>
                        Enquire
                    </Typography >
                    <Typography className={kdis?classes.active:classes.profnav} onClick={handleDis}>
                        Detect Disease
                    </Typography>
                   
                    <Typography className={req?classes.active:classes.profnav} onClick={handleReq}>
                        Requests
                    </Typography>
                </Grid>
                <Grid container item style={{padding:"1em",color:"#fff"}} className={classes.section1}>
                   { kdis&&<Grid className={classes.butarea}>
                        <Grid>
                            <Typography variant="h4">
                                Know the Disease
                            </Typography>   
                            <Typography style={{padding:"1em 0"}}>
                                Find the information of the disease and plant.
                                Be informative about the infection to save your previous crops
                                and prevent further damage by just clicking a photo.
                            </Typography>
                        </Grid>
                        <Grid>
                            <Link to="/disform" style={{textDecoration:"none"}}><Button style={{color:"#1E6F11",fontWeight:"600"}} variant="contained" color="secondary">Proceed</Button></Link>
                        </Grid>
                    </Grid>}
                   { enq&&<Grid className={classes.butarea}>
                        <Grid>
                            <Typography variant="h4" >
                                Enquire with our experts
                            </Typography>   
                            <Typography style={{padding:"1em 0"}}>
                               Find solution of your doubts with our experts and 
                               find a refernece to increase your production.Resolve your queries
                               by enquiring in your native language with a simple form.
                            </Typography>
                        </Grid>
                        <Grid>
                            <Link to="/expform" style={{textDecoration:"none"}}><Button style={{color:"#1E6F11",fontWeight:"600"}} variant="contained" color="secondary">Proceed</Button></Link>
                        </Grid>
                    </Grid>}
                    {
                        req&&<Grid item container justify="center" alignContent="center" alignItems="center"><UserRequest /></Grid>
                    }
                </Grid>
                </ThemeProvider>
        </div>
    );
}


